import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ServicioSesion } from '@app/services/sesion/sesion.service';
import { AuthService } from '@app/services/auth/auth.service';
import Swal from 'sweetalert2';

// Solo permite el acceso si NO hay sesión iniciada; si ya hay una, avisa y redirige a /main/torneos.
// El check local (localStorage) es por-origen: en un subdominio donde el usuario
// nunca inició sesión directamente, puede no haber nada ahí aunque sí exista una
// sesión válida en la cookie (compartida entre subdominios) — por eso, si local
// no encuentra nada, se confirma contra el server antes de asumir que no hay sesión.
export const sinSesionGuard: CanActivateFn = () => {
  const sesion = inject(ServicioSesion);
  const authService = inject(AuthService);
  const router = inject(Router);

  if (sesion.obtenerUsuarioActual()) {
    return _avisarYRedirigir(router);
  }

  return authService.getMe().pipe(
    map((res) => {
      sesion.guardarSesion(res.user);
      sesion.guardarContextos(res.contextos);
      return _avisarYRedirigir(router);
    }),
    catchError(() => of(true))
  );
};

function _avisarYRedirigir(router: Router) {
  Swal.fire({
    icon: 'info',
    title: '¡Bienvenido de nuevo!',
    text: 'Ya tienes una sesión iniciada, te llevamos a tus torneos.',
    timer: 3000,
    showConfirmButton: false,
  });

  return router.parseUrl('/main/torneos');
}
